import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=3e36ed38"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports